import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Article.css";
import NavComplete from "../Component/Navbar1";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Alert from "react-bootstrap/Alert";
import Footer from "../Component/footer";
import Card from "react-bootstrap/Card";
import LoadingImage from "../Component/Loadingimage";
import { useRef } from "react";
// {localStorage.getItem("bahasa") === "ing"?``:``}

const Article2 = () => {
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglescroll1 = () => {
    scrollToPromo(section1);
  };
  const togglescroll2 = () => {
    scrollToPromo(section2);
  };
  const togglescroll3 = () => {
    scrollToPromo(section3);
  };
  return (
    <article>
      {" "}
      <div id="containerss">
        <NavComplete />
        <Container
          className="info-page"
          style={{
            color: "white",
            marginTop: "80px",
            marginBottom: "80px",
            maxWidth: "900px",
            fontFamily: "nunito",
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href="/Informasi">Blog</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {localStorage.getItem("bahasa") === "ing"
                ? `This is what causes mold on the surface of car paint and glass`
                : `Ternyata Ini yang Menyebabkan Munculnya Jamur Pada Permukaan Cat dan Kaca Mobil`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col>
              <h1 style={{ fontFamily: "raleway" }}>
                {localStorage.getItem("bahasa") === "ing"
                  ? `This is what causes mold on the surface of car paint and glass`
                  : `Ternyata Ini yang Menyebabkan Munculnya Jamur Pada Permukaan Cat dan Kaca Mobil`}
              </h1>
              <div style={{ marginBottom: "15px", gap: "20px" }}>
                <i style={{ padding: "0px 2px" }} class="bi bi-person"></i>
                <a
                  style={{ padding: "0px 5px", marginRight: "10px" }}
                  target="blank_"
                  href="https://www.instagram.com/rezzaalviansyah/"
                >
                  Rezza
                </a>
                <i
                  style={{ padding: "0px 2px" }}
                  class="bi bi-calendar4-week"
                ></i>
                <span style={{ padding: "0px 5px" }}>25 oktober 2023</span>
              </div>
              <img
                src="https://i.ibb.co.com/PCNWxYQ/ezgif-com-gif-maker-1.webp"
                alt="moldy-car"
                className="info-image"
              />
              <Alert
                variant="dark"
                style={{
                  background:
                    "linear-gradient(156deg, rgba(0,0,0,1) 41%, rgba(250,0,8,1) 120%)",
                  color: "white",
                  borderColor: "red",
                }}
              >
                <h3>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Article Content: "
                    : "Isi Artikel: "}
                  {localStorage.getItem("bahasa") === "ing"
                    ? `This is what causes mold on the surface of car paint and glass`
                    : `Ternyata Ini yang Menyebabkan Munculnya Jamur Pada Permukaan Cat dan Kaca Mobil`}
                </h3>
                <ul>
                  <li onClick={togglescroll1}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Residual Water Sticking to the Car Body"
                      : "Sisa Air yang Menempel Pada Body Mobil"}
                  </li>
                  <li onClick={togglescroll2}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Rainwater"
                      : "Air Hujan"}
                  </li>
                  <li onClick={togglescroll3}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "High Air Humidity"
                      : "Kelembapan Udara Tinggi"}
                  </li>
                </ul>
              </Alert>
              <div style={{ textAlign: "start" }}>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? ` If you think that mold can only grow on food, fix your mistake! Because it turns out that mold can grow anywhere, including on the surface of your car's paint and glass. The mold can be seen from the white spots that stick to the surface of your car's paint and glass.`
                    : ` Kalo kamu beranggapan bahwa jamur itu hanya bisa tumbuh pada makanan, fix kamu salah! Karena ternyata jamur bisa tumbuh di mana saja, termasuk di permukaan cat dan kaca mobil kamu. Jamur itu bisa terlihat dari bercak-bercak putih yang menempel pada permukaan cat dan kaca mobil milikmu.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Although if you google the word "jamuran", you'll see that it's a traditional Javanese game, the term "jamuran" is more commonly understood as an expression that refers to something dirty.`
                    : ` Meskipun kalo kamu googling kata “jamuran”, maka akan muncul keterangan kalo jamuran itu permainan tradisional Jawa, tetapi istilah “jamuran” lebih dipahami masyarakat sebagai ungkapan yang merujuk pada sesuatu yang kotor.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? ` Just like when your car's paint and glass surfaces grow mold, there are definitely people around you who think that you as a car owner are slovenly, not neat, and can't take care of your car.`
                    : `Seperti halnya ketika permukaan cat dan kaca mobil milikmu tumbuh jamur, pasti ada saja orang-orang di sekeliling kamu yang beranggapan bahwa kamu sebagai pemilik mobil itu jorok, nggak apik, dan nggak bisa merawat mobil.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Even though you wash it regularly and clean it diligently, the mold still grows on the surface of your car's paint and glass. Are you confused as to why those molds keep growing? Let's take a look at the three causes of mold on the surface of your car's paint and glass!`
                    : `Padahal, kamu rutin mencucinya, rajin membersihkannya, tapi tetap saja jamur-jamur itu tumbuh pada permukaan cat dan kaca mobil kamu. Kamu bingung, kenapa jamur-jamur itu tetap tumbuh? Yuk, simak tiga penyebab munculnya jamur-jamur pada permukaan cat dan kaca mobil milikmu!`}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section1}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    1.{" "}
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Residual Water Sticking to the Car Body"
                      : "Sisa Air yang Menempel Pada Body Mobil"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/SPj1L9q/watery-car.webp"
                  alt="Watery car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Mold that appears on the surface of your car's paint and glass often occurs due to residual water that sticks to the body and glass of the car. All water contains minerals, and when evaporation occurs, the minerals will leave traces of calcium and magnesium.`
                      : `Jamur yang muncul pada permukaan cat dan kaca mobil milikmu itu sering terjadi akibat adanya sisa air yang menempel pada body dan kaca mobil. Semua air mengandung mineral, dan saat terjadi penguapan, maka mineral akan meninggalkan jejak berupa kalsium dan magnesium.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The longer this mineral pile sticks to the surface of your car's paint and glass, the harder and stickier the mold will appear. So, to prevent your car from getting moldy, make sure to always wash and wipe it completely dry!`
                      : `Semakin lama tumpukan mineral ini menempel pada permukaan cat dan kaca mobil milikmu, maka jamur yang muncul akan semakin keras dan menempel. Nah, agar mobil kamu tidak jamuran, pastikan untuk selalu mencucinya dan mengelapnya sampai benar-benar kering ya!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section2}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    2.{" "}
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Rainwater"
                      : "Air Hujan"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/Fw7Cqh0/waterys-car.webp"
                  alt="car in the rain"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `If you're one of those people who don't care after your car has been rained on, you need to change that habit because it's one of the causes of mold or water spots on your car's paint and glass surfaces.`
                      : `Kalo kamu termasuk orang yang bodo amatan setelah mobil kamu kehujanan, fix kamu harus mulai berubah! Karena, kebiasaan buruk itu menjadi salah satu penyebab munculnya jamur atau water spot pada permukaan cat dan kaca mobil milikmu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Apart from causing mold growth, there are a series of other dangers that will arise if the mold issue is taken lightly. Rainwater that is not immediately dealt with can cause porousness in the body of your car.`
                      : `Selain menyebabkan tumbuhnya jamur, ada sederet bahaya lainnya yang akan muncul kalo persoalan jamur dianggap sepele. Air hujan yang tidak segera diatasi bisa menimbulkan keropos pada body mobil kamu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The most dangerous thing is that when the mold is allowed to grow on the surface of your car's paint and glass, your vision while driving can be impaired, and it can cause accidents. Therefore, now you should start making it a habit to wash your rain-soaked car!`
                      : `Nah yang paling berbahaya adalah ketika jamur-jamur itu dibiarkan tumbuh pada permukaan cat dan kaca mobil kamu, maka pengelihatan kamu saat berkendara bisa terganggu, dan itu bisa menyebabkan kecelakaan. Maka dari itu, sekarang kamu harus mulai membiasakan untuk mencuci mobil kamu yang kehujanan!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section3}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    3.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "High Air Humidity"
                      : "Kelembapan Udara Tinggi"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/QCyvWGp/humidty.webp"
                  alt="Humid"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Entering the rainy season, your car needs extra care. The high amount of rainfall causes the air to become humid, and this situation accelerates the growth of mold on the surface of your car's paint and glass.`
                      : `Memasuki musim hujan, mobil kamu perlu perawatan ekstra. Tingginya curah hujan menyebabkan udara menjadi lembap, dan keadaan itu mempercepat pertumbuhan jamur pada permukaan cat dan kaca mobil milikmu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `So you need to pay attention to the humidity of your car's air temperature to suppress the growth rate of mold that can damage the outer appearance of your car. And a mold-free car will definitely add a sense of comfort when driving.`
                      : `Jadi kamu perlu memperhatikan kelembapan suhu udara mobil milikmu untuk menekan laju pertumbuhan jamur yang bisa merusak tampilan luar mobilmu. Dan mobil yang terbebas dari jamur sudah pasti akan menambah rasa kenyamanan saat berkendara.ma mungkin saja kamu bisa luka, yang kedua kuku bisa menimbulkan baret halus pada mobil kesayangan kamu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `One of the ways to love yourself is to take care of your hard-earned possessions. So, love your car, and don't let the paint and glass surfaces of your car get covered in mold!`
                      : `Nah, di antara cara mencintai diri sendiri (self love) adalah dengan merawat barang-barang yang telah dibeli dengan susah payah. Oleh karena itu, sayangilah mobilmu, dan jangan biarkan permukaan cat dan kaca mobilmu ditumbuhi jamur!.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Card
            className="bg-dark "
            style={{
              position: "relative",
              overflow: "hidden",
              alignSelf: "center",
            }}
            onClick={() => handleCardClick("/layanan-harga")}
          >
            <LoadingImage
              src="https://i.ibb.co.com/cgMDvsz/Coating-image.jpg"
              alt="Card image"
              className="card-overlay"
            />
            <Card.ImgOverlay
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "start",
                flexDirection: "column",
                color: "red",
              }}
            >
              <Card.Title>
                <b>Detailing</b>
              </Card.Title>
              <Card.Text
                style={{ backdropFilter: "blur(2px)", fontFamily: "raleway" }}
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Protect your car from mold with detailing at Wecarcare.`
                  : `Lindungi mobil anda dari Jamur dengan Detailing di Wecarcare`}
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Container>
        <Footer />
      </div>
    </article>
  );
};

export default Article2;
